import { fetchDataFromBackend } from "../api/api";
import logger from "../core/utils/logger";

const isSimulation = import.meta.env.VITE_BACKEND_DATA_SIMULATION === "true";

export const NotificationService = {
    async getNotificationPreference() {
        try {
            if (isSimulation) {
                logger.log("Simulation mode enabled. Returning default notification preference.");
                return { isEnabled: true };
            }

            const response = await fetchDataFromBackend("/NotificationPreference/preferences", {
                skipAuth: false,
                method: 'get'
            });

            logger.log("Notification preference response:", response);
            return response;
        } catch (error) {
            if (error.response?.status === 404) {
                logger.log("No notification preference found, returning default");
                return { isEnabled: true };
            }
            logger.error("Error fetching notification preference:", error);
            throw error;
        }
    },

    async saveNotificationPreference(isEnabled) {
        try {
            if (isSimulation) {
                logger.log("Simulation mode enabled. Simulated saving notification preference:", isEnabled);
                return { isEnabled };
            }

            const response = await fetchDataFromBackend("/NotificationPreference/preferences", {
                skipAuth: false,
                method: 'put',
                data: { isEnabled }
            });

            logger.log("Save notification preference response:", response);
            return response;
        } catch (error) {
            logger.error("Error saving notification preference:", error);
            throw error;
        }
    }
};
